'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = has;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Helper for common indexOf tests and object key existence
 *
 * Before:
 *
 * `if ('Hello World'.indexOf('World') !== -1) { /* ... * /}`
 * `if ('/manage/campaigns'.indexOf('/manage') === 0) { /* ... * /}`
 * `if (['cat', 'dog'].indexOf('dog') !== -1) { /* ... * /}`
 * `if (({ foo: true, bar: false }).hasOwnProperty('foo')) { /* ... * /}`
 *
 * After:
 *
 * `if (has('Hello World', 'World')) { /* ... * /}`
 * `if (has('/manage/campaigns', '/manage', 0)) { /* ... * /}`
 * `if (has(['cat', 'dog'], 'dog')) { /* ... * /}`
 * `if (has({ foo: true, bar: false }, 'foo')) { /* ... * /}`
 *
 * @param {string|object} target - String or object with indexOf function, or object (key test)
 * @param {string} value - String value for existence test
 * @param {number} index - Number index for exact position test (optional)
 *
 * @returns {string} Datetime string
 */
function has(target, value, index) {
  if (target === undefined || value === undefined) return false;

  if (typeof target.indexOf === 'function') {
    if (index !== undefined) {
      return target.indexOf(value) === index;
    }

    return target.indexOf(value) !== -1;
  }

  return (typeof target === 'undefined' ? 'undefined' : (0, _typeof3.default)(target)) === 'object' ? target.hasOwnProperty(value) : false;
}
//# sourceMappingURL=has.js.map